// extracted by mini-css-extract-plugin
export default {"root":"EditListingDBSPanel_root__Vki6Q","form":"EditListingDBSPanel_form__dJ12K","title":"EditListingDBSPanel_title__a8u9s"};